module.exports = __webpack_public_path__ + "img/warnellschoolgrotto-h-474x356.448b2d62.jpg";